import { PostHogProvider } from "posthog-js/react";
import type { PostHogConfig } from "posthog-js";

type AnalyticsProviderProps = {
	children: React.ReactNode;
};

const ENV = import.meta.env.VITE_ENV;

export const AnalyticsProvider: React.FC<AnalyticsProviderProps> = ({
	children,
}) => {
	const postHogApiKey = import.meta.env.VITE_PUBLIC_POST_HOG_KEY;
	const apiHost = "https://abc.coffitivity.com"; // our managed reverse proxy domain

	const postHogOptions: Partial<PostHogConfig> = {
		api_host: apiHost,
		ui_host: "https://us.posthog.com", // necessary because we're using a proxy, this way links will point back to PostHog properly
		person_profiles: "always", // turn this off if we're running a feature flag that doesn't need to persist across authentication
		disable_session_recording: ENV === "development",
	};

	return (
		<PostHogProvider apiKey={postHogApiKey} options={postHogOptions}>
			{children}
		</PostHogProvider>
	);
};
